import '../scss/site.scss';
import "@coso/layout/external-dependencies";
import "@coso/layout/external-dependencies/jquery-validation";
import { ThemeManager } from "@coso/layout";
import { defineCustomElements as defineLayoutElements } from "@coso/layout/loader";
defineLayoutElements();

const layoutElement: HTMLCosoLayoutElement = document.querySelector('coso-layout');
const siteContainer = document.getElementById("site");
const siteData = siteContainer?.dataset;

layoutElement.addEventListener('componentLoaded',
    (event: any) => {
        const container = document.getElementById("site");
        const loadingElement = document.querySelector(".loading-progress");
        layoutElement.className = "visible";
        if (container && loadingElement) {
            container.removeChild(loadingElement);
        }
    });

const shellEndpoint = getStringSetting("shellEndpoint");
const portalEndpoint = getStringSetting("portalEndpoint");

layoutElement.isMvc = getBooleanSetting("isMvc", true);
layoutElement.isIdentityProvider = true;
layoutElement.isAuthenticated = getBooleanSetting("isAuthenticated");
layoutElement.identityProviderEndpoint = getStringSetting("identityProviderEndpoint");
layoutElement.shellEndpoint = shellEndpoint;
layoutElement.dashboardEndpoint = getStringSetting("dashboardEndpoint");
layoutElement.menuLogoHref = "/";
layoutElement.tenantName = getStringSetting("tenantName");
layoutElement.userName = getStringSetting("userName");
layoutElement.supportsMultiTheme = true;
layoutElement.supportsTenantRename = getBooleanSetting("isSaasAdmin");
layoutElement.dataCenterEU = getStringSetting("dataCenter") == "ProductiveEU";
layoutElement.dataCenterUS = getStringSetting("dataCenter") == "Productive";

const footerElement: HTMLCosoFooterElement = document.querySelector('coso-footer');
footerElement.contactUsLink = {
    href: "https://portal.connecting-software.com/support/create-case/?subjectid=" + getStringSetting("portalSubjectId") + "&cs_deploymenttype=768880000&tenantid=" + getStringSetting("tenantId"),
    target: "_blank"
};
footerElement.termsAndConditionsLink = {
    href: portalEndpoint + "/support/SaaSServiceAgreement",
    target: "_blank"
};

footerElement.releaseNotesLink = { href: '/ReleaseNotes' };
footerElement.productVersion = "2.0.0";

ThemeManager.instance.theme$.subscribe((theme) => {
    const helperIframe = document.getElementById("helpSliderIframe") as HTMLIFrameElement;
    let serviceId = 0;
    if (helperIframe) {
        helperIframe.src = shellEndpoint + "/HelpSlider?serviceId=" + serviceId + "&theme=" + theme;
    }
});

function getStringSetting(key: string, fallback = ""): string {
    const value = siteData?.[key];
    return value ?? fallback;
}

function getBooleanSetting(key: string, fallback = false): boolean {
    const value = siteData?.[key];
    if (typeof value === "undefined") {
        return fallback;
    }

    return value.toLowerCase() === "true";
}
